module.exports = __webpack_public_path__ + "static/media/weed-control-icon.23437552.svg";